export default {"src":"/_next/static/media/footer-m.64c4e50a.svg","height":759,"width":1466,"blurWidth":0,"blurHeight":0};